import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, computed, PropType, watch } from "vue";
  import { useStore } from "vuex";
  import { useToast } from "vue-toastification";
  import ChartForReports from "@/components/reports/ChartForReports.vue";
  import { EstateInterface } from "@/types/EstateInterface";
  import { EoiStatus } from "@/enums/EoiStatus";
  import { EoiInterface } from "@/types/EoiInterface";
  import { ReportsTimePeriod } from "@/enums/ReportsTimePeriod";
  import { optionsForBarchart } from "@/constants/optionsChart";
  import { chartBackgroundColor } from "@/constants/optionsChart";
  import ReportsByNumber from "@/components/reports/ReportsByNumber.vue";

  interface EoisByEstate {
    title: string;
    status: string[];
    quantity: number[];
    total?: number;
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'AdminReportsByEOIs',
  props: {
    estate: {
      type: Object as () => EstateInterface,
      required: true,
    },
    period: {
      type: String as PropType<ReportsTimePeriod>,
      required: true,
    },
    role: {
      type: String,
      required: false,
    },
  },
  setup(__props, { expose: __expose }) {
  __expose();

  const props = __props;

  const store = useStore();
  const toast = useToast();
  const loading = ref(false);

  const eoisByEstate = ref<EoisByEstate>();
  const statusOrder = [
    EoiStatus.APPROVED,
    EoiStatus.DECLINED,
    EoiStatus.PENDING,
  ];

  const estateSelected = computed(() => {
    return props.estate;
  });

  const periodSelected = computed(() => {
    return props.period;
  });

  watch(periodSelected, (newPeriod, oldPeriod) => {
    if (newPeriod !== oldPeriod) {
      getEOIsByEstate();
    }
  });

  const getStatusCountsByEoi = (
    eois: EoiInterface[],
    statusOrderByEoi: string[]
  ) => {
    const statusCounts: { [key: string]: number } = {};

    for (const status of statusOrderByEoi) {
      statusCounts[status] = 0;
    }

    for (const eoi of eois) {
      const { status } = eoi;

      if (statusCounts[status] !== undefined) {
        statusCounts[status]++;
      }
    }

    return statusCounts;
  };

  const createEoiDataForChart = (
    estate: EstateInterface,
    statusForData: string[],
    statusCounts: { [key: string]: number }
  ) => {
    const eoiData: {
      title: string;
      status: string[];
      quantity: number[];
    } = {
      title: estate.title,
      status: [],
      quantity: [],
    };

    for (const status of statusForData) {
      eoiData.status.push(status);
      eoiData.quantity.push(statusCounts[status]);
    }

    return eoiData;
  };

  const filterEOIsByPeriod = (
    eois: EoiInterface[],
    period: ReportsTimePeriod
  ) => {
    const startDate = new Date();

    if (period === ReportsTimePeriod.LAST_WEEK) {
      startDate.setDate(startDate.getDate() - 7);
    } else if (period === ReportsTimePeriod.LAST_MONTH) {
      startDate.setMonth(startDate.getMonth() - 1);
      startDate.setDate(1);
    }

    return eois.filter((eoi) => {
      const createdAt = new Date(eoi.createdAt);

      return createdAt >= startDate;
    });
  };

  const getEOIsByEstate = async () => {
    loading.value = true;

    if (estateSelected.value) {
      store
        .dispatch("eoi/getEois", {
          estateId: estateSelected.value._id,
        })
        .then((res) => {
          const eoIsWithinPeriod = filterEOIsByPeriod(
            res.data,
            periodSelected.value
          );
          const statusCounts = getStatusCountsByEoi(
            eoIsWithinPeriod,
            statusOrder
          );
          const totalEois = eoIsWithinPeriod.length;

          eoisByEstate.value = {
            ...createEoiDataForChart(props?.estate, statusOrder, statusCounts),
            total: totalEois,
          };
        })
        .catch((err) => {
          toast.error("Error getting EOIs by estate");
        })
        .finally(() => {
          loading.value = false;
        });
    }
  };

  onMounted(() => {
    getEOIsByEstate();
  });

const __returned__ = { props, store, toast, loading, eoisByEstate, statusOrder, estateSelected, periodSelected, getStatusCountsByEoi, createEoiDataForChart, filterEOIsByPeriod, getEOIsByEstate, ref, onMounted, computed, PropType, watch, get useStore() { return useStore }, get useToast() { return useToast }, ChartForReports, get EstateInterface() { return EstateInterface }, get EoiStatus() { return EoiStatus }, get EoiInterface() { return EoiInterface }, get ReportsTimePeriod() { return ReportsTimePeriod }, get optionsForBarchart() { return optionsForBarchart }, get chartBackgroundColor() { return chartBackgroundColor }, ReportsByNumber }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})